/**
 * @file Global numbers
 */

// 104.8576 MB
export const BYTES_FOR_15_MIN_AUDIO_RECORDING = 104857600
// Please change the constant at GoogleCloudResumableUploader.capped_file_size_limit
// if we do change this.
// 2147.483648 MB
export const BYTES_FOR_5_MIN_VIDEO_RECORDING = 2147483648
export const MIN_PASSWORD_LENGTH = 8
export const MAX_PASSWORD_LENGTH = 128
